export default "__VITE_ASSET__Btach8OU__"